/**
 * Hooks for lookup data (banks, extraction methods)
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
// Types used by these hooks are inferred from API responses

// Query keys
export const lookupKeys = {
  all: ['lookups'] as const,
  banks: () => [...lookupKeys.all, 'banks'] as const,
  extractionMethods: () => [...lookupKeys.all, 'extractionMethods'] as const,
};

/**
 * Fetch list of banks
 */
export function useBanks() {
  return useQuery({
    queryKey: lookupKeys.banks(),
    queryFn: () => api.banks.list(),
    staleTime: 5 * 60 * 1000, // Banks don't change often - cache for 5 mins
  });
}

/**
 * Fetch list of extraction methods
 */
export function useExtractionMethods(includeDeprecated = true) {
  return useQuery({
    queryKey: [...lookupKeys.extractionMethods(), includeDeprecated],
    queryFn: () => api.extractionMethods.list(includeDeprecated),
    staleTime: 5 * 60 * 1000,
  });
}

// Bank Intelligence hook lives in ./useBankIntelligence — see that file
// for the typed BankIntelligence interface. Do NOT re-add a stub here;
// an earlier untyped `queryFn: async () => null` version was inferred as
// `never` by useQuery and broke HouseBankCard's entire typechain.
